/**
 * Fecha prevista propuesta para un pedido de compra a partir del plazo habitual del proveedor.
 *
 * Tiene que dar exactamente lo mismo que la API (`fechaPrevista` en `services/purchasing.ts`): el día de
 * hoy es el de Madrid, no el de UTC —a las 00:30 de Madrid en UTC todavía es ayer— y los días se suman
 * en UTC, que desborda mes y año sin sorpresas.
 *
 * Es solo una propuesta: si el usuario escribe otra fecha, se respeta la suya.
 */
export function fechaPrevista(plazoDias: number | null | undefined, ahora = new Date()): string {
  if (plazoDias === null || plazoDias === undefined || !Number.isFinite(plazoDias) || plazoDias < 0) return '';
  const dia = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid' }).format(ahora);
  const [anio, mes, diaMes] = dia.split('-').map(Number);
  return new Date(Date.UTC(anio, mes - 1, diaMes + plazoDias)).toISOString().slice(0, 10);
}
